import React, { useState } from 'react';
import './Footer.css';
import { useSelector } from "react-redux";

const MEDBUY_SHOW_COOKIE = 'MEDBUY-SHOW-COOKIE';

function gtag(){window.dataLayer.push(arguments);}

const FooterCookie = ({ getTranslate }) => {
    const id_customer = useSelector((state) => state.auth.user ? state.auth.user.id : false);
    const [show, setShow] = useState(!localStorage.getItem(MEDBUY_SHOW_COOKIE) ?? true);

    const handleAcceptCookie = (accepted, id_customer) => {
        window.dataLayer = window.dataLayer || [];

        // if (accepted) {
        //     gtag('consent', 'update', {
        //         'ad_storage': 'granted',
        //         'analytics_storage': 'granted',
        //         'functionality_storage': 'granted',
        //         'personalization_storage': 'granted',
        //         'security_storage': 'granted',
        //     });
        // } else {
        //     gtag('consent', 'update', {
        //         'ad_storage': 'denied',
        //         'analytics_storage': 'denied',
        //         'functionality_storage': 'denied',
        //         'personalization_storage': 'denied',
        //         'security_storage': 'denied',
        //     });
        // }

        localStorage.setItem(MEDBUY_SHOW_COOKIE, '1');
        setShow(false);
    };

    console.log('show cookie', show);

    return show && <div className={"cookie_container"}>
        <p className={"cookie_text_info"}>{getTranslate('front_footer', 'cookie_text')}</p>
        <form className={"cookie_form"} onSubmit={(event) => {
            event.preventDefault();
        }}>
            <button onClick={() => handleAcceptCookie(true, id_customer)}>{getTranslate('front_footer', 'cookie_button_accept')}</button>
            <button onClick={() => handleAcceptCookie(false, id_customer)}>{getTranslate('front_footer', 'cookie_button_decline')}</button>
        </form>
    </div>
}

export default FooterCookie;
